import { Tag, Space, Card } from 'antd';
import React from 'react';

function Tags() {
  return (
    <Card title="Tags">
      <Space>
        <Tag>Metis</Tag>
        <Tag closable>Adrastea</Tag>
        <Tag color="geekblue">Amalthea</Tag>
        <Tag color="cyan">Thebe</Tag>
        <Tag color="blue" closable>Callisto</Tag>
      </Space>
    </Card>
  )
}

export default Tags;
